import styled from 'styled-components';
import { pxToRem } from 'utils/convert';
import { fonts } from 'ui/theme';

export const PageContainer = styled.div`
  min-width: ${pxToRem(1612)};
  font-family: ${fonts.sansSerif};
`;
